import { render, staticRenderFns } from "./SiteWorkspace.vue?vue&type=template&id=21ed7e56"
import script from "./SiteWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteWorkspace.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports